import { computed } from 'vue';
import { RouteLocation, Router } from 'vue-router';

export function useCommonFilters(route: RouteLocation, router: Router) {
  const hasSomeFilters = computed<boolean>(() => Object.keys(route.query).some((q) => ![
    'categoriesIds',
    'state',
  ].includes(q)));

  async function clearAllFilters() {
    const query = { ...route.query };

    Object.keys(route.query).forEach((q) => {
      if (q === 'state') return;

      delete query[q];
    });

    await router.push({ query });
  }

  return {
    hasSomeFilters,
    clearAllFilters,
  };
}
